export default __webpack_public_path__ + "images/UE.27b6cba.png";